import { config } from '@iheartjane/config';
import { createConsumer } from '@rails/actioncable';

import { parseToken } from './jwt';

const buildUrl = (jwt: string) =>
  [config.actionCablePath, `?token=${parseToken(jwt)}`].join('');

export const initCable = (jwt: string) => createConsumer(buildUrl(jwt));
